import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/audit/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/admin/audit/change-timeline", search, replace: true });
    },
});
